import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../../foundation/altzero_base/base/components/ui/select';
import { STEP_LABELS, type WorkflowStep } from '../../lib/billWorkflow';

// "Set status…" for the selected rows, on every bill list (spec 2026-10-19).
// Every person-set step is offered, as on the board since migration 131: a step
// set before a bill reaches it waits (lib/billWorkflow.billWorkflowStatus).

const CLEAR = '__clear__';

type BulkStatusSelectProps = {
  testId: string;
  /** Pass true while a save is in flight so a second pick cannot overlap it. */
  disabled?: boolean;
  onSet: (step: WorkflowStep | null) => void;
};

export const BulkStatusSelect = ({ testId, disabled, onSet }: BulkStatusSelectProps) => (
  <Select
    value=""
    disabled={disabled}
    onValueChange={(v) => onSet(v === CLEAR ? null : (v as WorkflowStep))}
  >
    <SelectTrigger data-testid={testId} aria-label="Set status for selected bills" className="h-8 w-44 text-xs bg-white">
      <SelectValue placeholder="Set status…" />
    </SelectTrigger>
    <SelectContent>
      {(Object.keys(STEP_LABELS) as WorkflowStep[]).map((step) => (
        <SelectItem key={step} value={step} className="text-xs">{STEP_LABELS[step]}</SelectItem>
      ))}
      <SelectItem value={CLEAR} className="text-xs">Clear status step</SelectItem>
    </SelectContent>
  </Select>
);
